const HandsonsData_Customer = {}

HandsonsData_Customer.defaultState = {
  activeTab: '1',

  stateModal: false,
  messege: 'sample messege',
  messege2: '',
  messege3: '',
  messege4: '',
  messege5: '',

  write_disabled: true,
  delete_disabled: true,
  Button_hidden: false,
  New_hidden: true,
  Details_hidden: true,
  Admin_hidden: true,

  Btn_hidden_Regist: true,
  Btn_hidden_Fix: true,
  Btn_hidden_Cansel: true,
  Btn_hidden_EditSave: true,
  Btn_hidden_Remand: true,
  Btn_hidden_Approval: true,
}



HandsonsData_Customer.colHeaders_Name = [
  '削除',
  'End Customer Alias',
  'End Customer ID',
  'Disti',
  'Remark',
  // 'create_time',
  // '代理店',
  // '代理店（日本語）',
  // '代理店ID',
  // '代理店郵便番号',
  // '代理店住所',
  // '代理店電話番号',
  // '代理店担当者1（窓口）',
  // '代理店担当者2（窓口）',
  // 'JA担当者',
  // 'JQ担当者',
  // '作成日',
  // 'yobi' 
];



HandsonsData_Customer.columns_Data = [
  {
    data: 'delete_Flag',
    type: "checkbox",
    className:'htCenter',
    checkedTemplate: "1",
    uncheckedTemplate: "0"
  },
  { data: 'EndCustomer' },
  { data: 'EndCustomerID' },
  { data: 'Disti' },
  { data: 'Remark' },
  // {data: 'create_time', readOnly: true },
  // {
  //   data: 'EndCustomer',
  //   type: "dropdown",
  //   source:["aaa","bbb","ccc","ddd" ],
  // },

  // { data: 'EndCustomerJP' },
  // { data: 'EndCustomerID' },
  // { data: 'CustomerGroupJQ' },
  // { data: 'application' },
  // { data: 'affiliate' },
  // { data: 'affiliateJP' },
  // { data: 'affiliateID' },
  // { data: 'affiliateZip' },
  // { data: 'affiliateAddress' },
  // { data: 'affiliateTel' },
  // { data: 'affiliateStaff1' },
  // { data: 'affiliateStaff2' },
  // { data: 'JAStaff' },
  // { data: 'JQStaff' },
  // {data: 'partition_key', readOnly: true},

  // {data: 'mode'},
  // {data: 'type'},
  // {data: 'status'},
  // {data: 'Request_No'},
  // {data: 'Project_No'},
  // {data: 'yobi'}
];


HandsonsData_Customer.data = [
];

HandsonsData_Customer.sampledata = [
  {
    delete_Flag: "0",
    partition_key: "Customer",
    create_time: '',
    mode: "",
    type: "",
    status: "",
    EndCustomer: "",
    EndCustomerID: "",
    Disti: "",
    Remark: "",
    // affiliate: "",
    // affiliateJP: "",
    // affiliateID: "",
    // affiliateZip: "",
    // affiliateAddress: "",
    // affiliateTel: "",
    // affiliateStaff1: "",
    // affiliateStaff2: "",
    // JAStaff: "",
    // JQStaff: "",
    // yobi: ""
  },
];

export default HandsonsData_Customer
